import React, { useContext, useEffect, useMemo, useState } from "react";
import styles from "./index.module.scss";
import { AvatarContext } from "../../../../contexts/AvatarContext/AvatarContextProvider";
import { avatarObj } from "../ProfileScreen/avatarCustomisationData";

const CustomAvatar = ({ avatarOptions, avatarBody }) => {
  const { handleUpdateAvatar, state } = useContext(AvatarContext);
  const [avatarCustomisationOptions, setAvatarCustomisationOptions] = useState(
    []
  );
  useEffect(() => {
    setAvatarCustomisationOptions(Object.values(avatarOptions[state.gender]));
  }, [state.gender]);

  return (
    <div ref={avatarBody} className={styles.selectedAvatar}>
      {/* {Object.values(state).map((value) => {
        return (
          <img
            key={value.id}
            className={styles.avatarImage}
            style={{ zIndex: value.zIndex }}
            src={value.img}
            alt="selectedAvatar"
          />
        );
      })} */}
      {avatarCustomisationOptions &&
        avatarCustomisationOptions.length > 0 &&
        avatarCustomisationOptions.map((avatar) =>
          avatar.multiple ? (
            avatar.options.map((_avat) =>
              state && state[_avat.id] ? (
                <img
                  key={_avat.id}
                  className={styles.avatarImage}
                  style={{ zIndex: state[_avat.id].zIndex }}
                  src={state[_avat.id].img}
                  alt="selectedAvatar"
                />
              ) : null
            )
          ) : state[avatar.id] ? (
            <>
              <img
                key={avatar.id}
                className={styles.avatarImage}
                style={{ zIndex: state[avatar.id].zIndex }}
                src={state[avatar.id].img}
                alt="selectedAvatar"
              />
            </>
          ) : null
        )}
    </div>
  );
};

export default CustomAvatar;
